import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { CreateBuildingForm } from '@/features/Building/CreateBuildingForm'
import { useTranslation } from 'react-i18next'

type CreateBuildingModalProps = {
  dialogProps: AlertDialogProps
  selectResidentialId?: number
  onCloseModal: () => void
}

export const CreateBuildingModal: FC<CreateBuildingModalProps> = props => {
  const { dialogProps, selectResidentialId, onCloseModal } = props
  const { t } = useTranslation(['building'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('building:create_building_modal_title')}</DialogTitle>
          <CreateBuildingForm
            onCloseModal={onCloseModal}
            selectResidentialId={selectResidentialId}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
